import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ClientePortalUser {
  id: string;
  user_id: string;
  email: string;
  rol: string;
  created_at: string;
}

export function useClienteAccesses(clienteId: string | null) {
  return useQuery({
    queryKey: ["cliente-accesses", clienteId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_cliente_portal_users", {
        _cliente_id: clienteId!,
      });
      if (error) throw error;
      return (data ?? []) as ClientePortalUser[];
    },
    enabled: !!clienteId,
  });
}

export function useInviteClienteUser() {
  const { orgId } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (vars: { email: string; cliente_id: string }) => {
      if (!orgId) throw new Error("Sin organización activa");
      const { data, error } = await supabase.functions.invoke("invite-cliente-user", {
        body: { email: vars.email, cliente_id: vars.cliente_id, org_id: orgId },
      });
      if (error) throw new Error(error.message || "Error al invitar");
      if ((data as any)?.error) throw new Error((data as any).error);
      return data;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ["cliente-accesses", vars.cliente_id] });
    },
  });
}

export function useRevokeClienteAccess() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { id: string; cliente_id: string }) => {
      const { error } = await supabase.from("cliente_users").delete().eq("id", vars.id);
      if (error) throw error;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ["cliente-accesses", vars.cliente_id] });
    },
  });
}
